/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { Triangle } from "react-loader-spinner";
import { jwtDecode } from "jwt-decode";
import toast from "react-hot-toast";
export default function ProtectedRoute({ children }) {
  const initialUser = JSON.parse(secureLocalStorage.getItem("profile"));
  const [user, setUser] = useState(initialUser);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    setUser(initialUser);
  }, []);
  const decodedToken = user ? jwtDecode(user?.token) : "";

  const exp = decodedToken.exp;

  useEffect(() => {
    const expirationDate = new Date(exp * 1000);
    const currentDate = new Date();

    // Check if the expiration date is in the past
    if (currentDate > expirationDate) {
      navigate("/assets-register/login");
      toast.error("Your session has expired, please log in again");
    }
  }, [exp, navigate]);
  useEffect(() => {
    if (!user) navigate("/assets-register/login");
  }, [user, navigate]);
  useEffect(() => {
    if (user?.results.assets === "Restricted") {
      toast.error("You are not allowed to access this system");
      navigate("/assets-register/login");
    }
  }, [user, navigate]);
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, [navigate]);
  if (isLoading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
        <Triangle
          visible={true}
          height='80'
          width='80'
          color='#4fa94d'
          ariaLabel='triangle-loading'
          wrapperStyle={{}}
          wrapperClass=''
        />
      </div>
    );
  }
  if (user) return children;
}
